declare const process: {
	env: Record<string, string | undefined>;
};

const isLocalHost = (host: string) => host === 'localhost' || host === '127.0.0.1';

const getApiBase = () => {
	const configured = (process.env.REACT_APP_API_URL || '').trim();

	if (!configured) {
		return '';
	}

	// Si el build trae localhost pero estamos en dominio público, usar mismo origen.
	try {
		const configuredUrl = new URL(configured);
		const runningInBrowser = typeof window !== 'undefined';
		if (runningInBrowser && !isLocalHost(window.location.hostname) && isLocalHost(configuredUrl.hostname)) {
			return '';
		}
		return configuredUrl.origin;
	} catch {
		return configured.replace(/\/$/, '');
	}
};

const API_BASE = getApiBase();
const CONCURSO_API = process.env.REACT_APP_CONCURSO_API_URL || 'https://concurso-preguntas-production.up.railway.app';

export const getApiUrl = (path: string) => `${API_BASE}${path}`;
// imagePath viene del JSON como '/images/portadas/...' o '/images/personajes/...'
export const getImageUrl = (imagePath: string) => `${CONCURSO_API}/static${imagePath}`;
